import { useState, useEffect } from "react";
import { Box, FormControlLabel, FormLabel, RadioGroup, Radio, TextField, Typography, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateSection } from "../../../store/Profiles/profilesSlice";

const StepEducation = ({ onNext, onBack }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    // Obtener datos desde Redux
    const storedData = useSelector((state) => state.profiles.Education) || {};

    // Estado inicial con valores por defecto
    const [formData, setFormData] = useState({
        EducationalLevel: "",
        ReadingAbility: "",
        RaceEthnicity: "",
        OtherRaceEthnicity: ""
    });

    // Cargar datos guardados cuando cambie storedData
    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            ...storedData
        }));
    }, [storedData]);

    // Manejar cambios en los inputs
    const handleChange = (field, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [field]: value
        }));
    };

    // Guardar datos en Redux y pasar al siguiente paso
    const handleNextStep = async () => {
        await handleSaveData();
        onNext();
    };

    // Guardar en Redux
    const handleSaveData = async () => {
        dispatch(updateSection({ section: "Education", data: { Education: formData } }));
    };

    return (
        <>
            <Typography variant="h5" gutterBottom>{t("Profiles.Education.Education")}</Typography>

            {/* Nivel Educativo */}
            {/* Nivel Educativo */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <FormLabel component="legend">{t("Profiles.Education.Educationallevel")}</FormLabel>
                <RadioGroup 
                    row
                    value={formData.EducationalLevel}
                    onChange={(e) => handleChange("EducationalLevel", e.target.value)}
                >
                    <FormControlLabel value="grade_school" control={<Radio />} label={t("Profiles.Education.GradeSchool")} />
                    <FormControlLabel value="middle_school" control={<Radio />} label={t("Profiles.Education.HighSchool/GED")} />
                    <FormControlLabel value="high_school" control={<Radio />} label={t("Profiles.Education.AssociatesDegree")} />
                    <FormControlLabel value="associates" control={<Radio />} label={t("Profiles.Education.MiddleSchool")} />
                    <FormControlLabel value="graduate" control={<Radio />} label={t("Profiles.Education.Graduate/PostGrad")} />
                </RadioGroup>
            </Box>

            {/* Habilidad de Lectura */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                <FormLabel component="legend">{t("Profiles.Education.ReadingAbility/Literacy")}</FormLabel>
                <RadioGroup 
                    row
                    value={formData.ReadingAbility}
                    onChange={(e) => handleChange("ReadingAbility", e.target.value)}
                >
                    <FormControlLabel value="High" control={<Radio />} label={t("Profiles.Education.High")} />
                    <FormControlLabel value="Moderate" control={<Radio />} label={t("Profiles.Education.Moderate")} />
                    <FormControlLabel value="Limited" control={<Radio />} label={t("Profiles.Education.Limited")} />
                </RadioGroup>
            </Box>

            {/* Raza / Etnicidad */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                <FormLabel component="legend">{t("Profiles.Education.Race/Ethnicity")}</FormLabel>
                <RadioGroup 
                    row
                    value={formData.RaceEthnicity}
                    onChange={(e) => handleChange("RaceEthnicity", e.target.value)}
                >
                    <FormControlLabel value="African" control={<Radio />} label={t("Profiles.Education.African")} />
                    <FormControlLabel value="American/Black" control={<Radio />} label={t("Profiles.Education.American/Black")} />
                    <FormControlLabel value="Latino/Hispanic" control={<Radio />} label={t("Profiles.Education.Latino/Hispanic")} />
                    <FormControlLabel value="Asian/PacificIslander" control={<Radio />} label={t("Profiles.Education.Asian/PacificIslander")} />
                    <FormControlLabel value="NativeAmerican" control={<Radio />} label={t("Profiles.Education.NativeAmerican")} />
                    <FormControlLabel value="Black/Haitian" control={<Radio />} label={t("Profiles.Education.Black/Haitian")} />
                    <FormControlLabel value="White/Non-Hispanic" control={<Radio />} label={t("Profiles.Education.White/Non-Hispanic")} />
                    <FormControlLabel value="Other" control={<Radio />} label={t("Profiles.Education.Other")} />
                </RadioGroup>
                {formData.RaceEthnicity === "Other" && (
                    <TextField 
                        fullWidth 
                        label={t("Profiles.Education.Other")} 
                        margin="normal"
                        value={formData.OtherRaceEthnicity}
                        onChange={(e) => handleChange("OtherRaceEthnicity", e.target.value)}
                    />
                )}
            </Box>

            {/* Botones */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined">
                    {t("common.back")}
                </Button>
                <Button endIcon={<ArrowForwardIcon />} onClick={handleNextStep} variant="contained" color="primary">
                    {t("common.next")}
                </Button>
            </Box>
        </>
    );
};

export default StepEducation;
